export default {
	bookABox: 'Box booking',
	chooseABox: 'Choose a box',
	stock: 'Stock',
	address: 'Address',
	aip: 'Zip',
	selectStock: 'Check location',
	boxesAvailable: 'Boxes available',
	totalBoxesNumberAtStock: 'Total boxes at stock',
	sizes: 'Sizes',
	contractDuration: 'Contract duration',
	paymentFrequency: 'Payments frequency',
	payRarePayLess: 'Pay rarely - pay less!',
	payRareHelpBlock: 'The less frequent the frequency of payments - the greater the discount!',
	totalToPay: 'Total to pay',
	includedInsurance: 'incl. insurance',
	inclVAT: 'incl. VAT',
	notInclVAT: 'Without VAT',
	toBookABox: 'In order to book a box, please,',
	authorize: 'Authorize',
	iAgree: 'By clicking Confirm, you accept the following documents:',
	contractAgreementDoc: 'Box Lease Agreement (Preview)',
	stockRoutine: 'Stock routine',
	privacyPolicy: 'Privacy Policy',
	companyRules: 'General company rules',
	contractTerms: 'General contract terms',
	notAvailable: 'Not available',
	step1SelectTheSizeOfTheBox: 'Step 1. Select the size of the box',
	step2SelectTheSizeOfTheBox: 'Step 2. Select the size of the box',
	step3SelectABoxOnTheMap: 'Step 3. Select a box on the map',
	month: 'month',
	week: 'week',
	forWholePeriod: 'Total',
	saveAmount: 'Save',
	discount: 'Discount',
	cancel: 'Cancel reservation',
	areYouSureToCancelReservation: 'Are you sure you want to Cancel reservation ?',
	insuranceAmount: (amount) => `With our basic storage insurance, your items are insured for ${amount} EUR`,
	reserveWithRequiredPayment: 'Book with mandatory payment',
	reserveWithPayPal: 'Book with PayPal',
	reserveViaBankTransfer: 'Book using bank transfer',
	iHaveReadDocsAndAgree: 'I have read the following additions to the contract and accept them in full.',
	sizesMeta: {
		s: `You can fit here: <br />
		&#183; 40-200 cartons/boxes or<br />
		&#183; 2-8 shelving units or<br />
		&#183; up to 4 pallets or<br />
		&#183; equipment from room of up to 35m2<br /> <br />
		Choose this option for example to store seasonal things, family souvenirs or small company archive.
		`,
		m: `You can fit here: <br />
		&#183; 210-300 cartons or<br />
		&#183; 9-14 shelving units or<br />
		&#183; do 7 pallets<br />
		&#183; equipment from room of up to 50m2<br /> <br />
		This is going to work if you are renovating the whole apartment or office, if you are moving or if you have a small internet store.
		`,
		l: `You can fit here: <br />
		&#183; 320-1020 cartons or<br />
		&#183; 15-35 shelving units or<br />
		&#183; do 18 pallets or<br />
		&#183; equipment from apartment of up to 80m2<br /> <br />
		Perfect solution for small and medium companies and if you are emptying a 100m building.
		`,
		xl: `You can fit here: <br />
		&#183; 700-1000 cartons or<br />
		&#183; 10-15 shelving units or<br />
		&#183; 15-20 pallets or<br />
		&#183; equipment from room of up to 100m2<br /> <br />
		This is a really big space. Choose this option if you need a storage for your business.
		`,
	},
	sizesMetaTBDE: {
		s: 'Sufficient for household items up to 50 m² or for the archive up to 80 boxes',
		m: 'Sufficient for household items from 55 m² to 100 m² or for the archive from 85 to 160 boxes',
		l: 'Sufficient for household items from 100 m² to 200 m² or for the archive from 165 to 320 boxes',
		xl: 'Sufficient for household goods from 200 m² to 300 m² or for the archive from 330 to 480 boxes'
	},
	tariffs: {
		basic: 'The tariff is valid when signing a contract for an indefinite period with a 21-day notice period and when concluding a contract for a definite period of less than 6 months',
		smart: 'Average monthly rate for a fixed-term contract for a period of 6 to 11 months. The 30% discount is calculated for the 6th month.',
		max: 'Average monthly rate for a fixed-term contract for 12 months. The 65% discount is calculated for the 12th month.',
		week: 'Monthly rate for an open-ended contract with 7-days notice period.'
	},
	insuranceCoverage: 'Insurance coverage',
	englishWordOr: 'or',
	yourChoice: 'Your choice',
	freeBoxesOfTheRightSize: 'Free boxes of the right size',
	occupiedBoxes: 'Occupied boxes',
	continue: 'Continue',
	reservations: 'Reservations',
	bookWithoutPayment: 'Reserve without payment',
	bookAndPay: 'Book and pay',
	choiceOfArrivalDateTitle: 'Move-in date',
	choiceOfArrivalDateText: 'When do you need your box',
	choiceOfDepartureDateTitle: 'Move out date',
	choiceOfArrivalDatePlaceholder: 'Choose a date',
	successTitle: ['Congratulations!', 'Box has been successfully reserved.'],
	successText: 'Please, check your e-mail and sign a contract. It can be inside spam folder. Box will be available from the date of the contract after payment of the invoice.',
	selectUser: 'Select User',
	user: 'User',
	docsAgreement: 'Docs agreement',
	payment: 'Payment',
	openEndedContractNote: 'This is an open-ended contract, which will run until you cancel it. The chosen term represents your cancellation option.',
	openEndedContractNoteTopBox: 'It is a permanent contract with a minimum contract period. After the minimum contract period has expired, the contract is automatically renewed monthly until it is terminated with a notice period of 14 days.',
	back: 'Back',
	close: 'Close',
	insuranceWillBeAdded: '+insurance',
	automaticPaymentsText: 'Automatic monthly payment',
	searchHeader: 'Search this map',
	cityOrStockName: 'Сity or stock',
	sendPhotos: 'Send photo',
	uploadDocsPhoto: 'Upload docs photo',
	bookingByTheAdministrator: 'Booking by the administrator is prohibited! Log in as a user.',
	chooseYourInsurance: 'Choose your insurance',
	valueOfGoods: 'Value of goods',
	oneEuroForFirstMonth: '1st month for 1 Euro',
	boxNumber: 'Box number',
	minimalRentPeriodDescription: 'Minimum rental period 2 months',
	forTwoInitialMonths: 'For the first 2 months',
	forInitialServicePeriod: 'Your first invoice will conclude a refundable deposit and insurance fee',
	twoInitialMonthsInsuranceDescription: 'incl. storage insurance',
	price: 'Price',
	prices: 'Prices',
	selectBoxSize: 'Select box size',
	enterDataAndPayment: 'Enter data & payment',
	bookingParams: 'Enter data',
	reserveOrPay: 'Book or pay',
	andPayLater: 'Und später bezahlen',
	payLaterDesctiption: 'You will find invoice in your account',
	contactSource: 'How did you find out about us',
	reasonForStorage: 'Storage Reason',
	areYouSureToCreateAContract: 'Are you sure you want to create a contract?',
	enterIntoContractExplanation: `By clicking "Enter into contract" you will perform contract creation.
		You will receive contract signment link to your email and initial invoice.
		After you pay invoice whole access to stock and your box will be granted to you.`,
	reservationId: 'Reservation',
	expires: 'Expires',
	expired: 'Reservation expired !',
	box: 'Box',
	startRentDate: 'Start rent date',
	endRentDate: 'End rent date',
	initialPayment: 'The first payment including refundable deposit',
	enterIntoContract: 'Enter into contract',
	details: 'Details',
	rentalCost: 'Rental cost',
	insurance: 'Insurance amount',
	deposit: 'Deposit',
	vatAmount: 'VAT',
	boxLeaseAgreement: 'Box lease agreement with Rentabox LLC',
	mapAndList: 'Map & list',
	map: 'Map',
	list: 'List',
	step3SelectABox: 'Step 3. Select a box',
	boxesFromAnotherCategory: 'Boxes from another size category',
	selectOnMap: 'Choose',
	move: 'Move',
	zoomIn: 'Zoom in',
	stockAddess: 'Stock address',
	zoomOut: 'Zoom out',
	stretch: 'Stretch',
	reservationDescription: 'Reservation is free. To gain access to your warehouse, visit our office no later than 3 days after making the reservation or conclude the contract online yourself, on your client account.',
	paymentFromSecondMonth: 'Payment from second month',
	paymentFromSecondWeek: 'Payment from second week',
	specialMonthPaymentDescription: (specialMonth, discountPercent) => `Payment for ${specialMonth}th month with ${discountPercent}% discount`,
	reservationWithoutDepartureDateDescription: 'Indefinite period, notice period - 21 days',
	readDocsAndAgree: () => 'I declare that I have read the rental agreement with attachments and fully accept all the terms and conditions.',
	cantPreview: (link) => `Can't preview, download <a href=${link}>document</a>`,
	getRoute: 'Get route',
	useAutoPayments: 'Allow autopayments',
	oneEuroActionDescription: 'Our €1 promotion is only valid for new customers with a minimum rental period of 2 months.',
	oneEuroActionWasRemoved: `
	<h4>Dear Sir or Madam,</h4>
		The €1 promotion has been removed from your booking as it is only valid for new customers with a minimum rental period of 2 months.<br />
		Thank you for understanding.<br /><br />
		Sincerely<br />
		Your Top Box Team!<br />
	`,
	externalBoxDescription: (link) => `The selected box requires receiving the key from the reception before moving in ( <a href=${link}>CHECK OPENING HOURS</a> )`,
	viewThisbox: 'View this box ->',
	andDeposit: 'and Deposit',
	depositWillBeReturned: (amount) => `The security deposit (${amount}€) will be returned back to you after contract is terminated`,
	includedInsuranceFull: 'Including insurance',
	carLimitsWarning: `
		<span style="font-size: 18px"><b>Caution!</b></span> <br>
		Entering the territory only for vehicles up to <br><b>3,05m</b>! <br>
		Possibility for entering for the higher vehicles only during the office working hours<br>
		PN-PT: 08.00-19.00 <br>
		SOB: 10.00-15.00 <br>
	`
};
